var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 34.25V37.625H14.4889L3.375 48.7389L5.76113 51.125L16.875 40.0111V47.75H20.25V34.25H6.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.875 35.9375H40.5V44.375H43.875V35.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.125 27.5H33.75V44.375H37.125V27.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.375 30.875H27V44.375H30.375V30.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25 3.875H6.75C5.85517 3.87589 4.99724 4.23176 4.3645 4.8645C3.73176 5.49724 3.37589 6.35517 3.375 7.25V27.5H6.75V22.4375H47.2517L47.2534 47.75H27V51.125H47.25C48.1447 51.1238 49.0025 50.7678 49.6352 50.1352C50.2678 49.5025 50.6238 48.6447 50.625 47.75V7.25C50.624 6.35521 50.2681 5.49736 49.6354 4.86465C49.0026 4.23194 48.1448 3.87603 47.25 3.875ZM20.25 19.0625H6.75V7.25H20.25V19.0625ZM23.625 19.0625V7.25H47.25L47.2512 19.0625H23.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDashboard);
export default __webpack_public_path__ + "static/media/my-dashboard.859e231ad2b400d10f04ea2424084edc.svg";
export { ForwardRef as ReactComponent };